import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import clsx from 'clsx'

import './index.scss'
import FieldErrorSection from '@Components/Fields/FieldErrorSection'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import dayjs from 'dayjs'

interface DatePickerProps {
    value?: Date | null
    label?: string
    assistiveText?: string
    errorMessage?: string
    maxDate?: Date
    minDate?: Date
    disabled?: boolean
    id: string
    onChange: (date: string, id: string) => void
    required?: boolean
    helperTitle?: string
    helperTitleText?: string
    helperType?: '?' | 'i'
}

const DatePickerComponent = ({
    value,
    label,
    assistiveText,
    errorMessage,
    maxDate,
    minDate,
    disabled,
    id,
    onChange,
    required,
    helperTitle,
    helperTitleText,
    helperType,
}: DatePickerProps) => {
    const [dateValue, setDateValue] = useState<Date | null>(value || null)
    const [activeInputState, setActiveInputState] = useState(false)

    const onBlurInput = () => setActiveInputState(false)

    const onFocusInput = () => setActiveInputState(true)

    const handleChange = (e: Date | null) => {
        setDateValue(e)
        onChange(e ? dayjs(e).format() : '', id)
        onBlurInput()
    }

    useEffect(() => {
        if (value !== undefined) {
            setDateValue(value)
        }
    }, [value])

    const classNames = clsx(
        'input-text-component',
        'main-color-set',
        'datepicker-custom-component',
        activeInputState && 'focused',
        dateValue && 'filled',
        disabled && 'disabled',
        errorMessage && 'error'
    )

    return (
        <div className={classNames}>
            <label>{label}</label>
            {helperTitleText && (helperTitle || helperType) && (
                <CustomToolTip title={helperTitle} info={helperTitleText} type={helperType} />
            )}
            <DatePicker
                maxDate={maxDate ? maxDate : new Date('2100-12-31')}
                minDate={minDate ? minDate : new Date('1900-01-01')}
                showPopperArrow={false}
                dateFormat="MMMM d yyyy"
                selected={dateValue}
                onChange={handleChange}
                onBlur={onBlurInput}
                onFocus={onFocusInput}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                isClearable
                disabled={disabled}
            />
            <FieldErrorSection errorMessage={errorMessage} assistiveText={assistiveText} required={required} />
        </div>
    )
}

export default DatePickerComponent
